import moment from 'moment'
import store from '@/store'

/* OBJECT HELPERS */

export const isEqualObject = (value, other) => {
  const type = Object.prototype.toString.call(value)
  if (type !== Object.prototype.toString.call(other)) return false

  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length
  const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  const compare = (item1, item2) => {
    const itemType = Object.prototype.toString.call(item1)

    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqualObject(item1, item2)) return false
    } else {
      if (itemType !== Object.prototype.toString.call(item2)) return false
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false
      } else {
        if (item1 !== item2) return false
      }
    }
  }

  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  return true
}

export const isEmptyObject = (obj) => {
  for (const key in obj) {
    if (key) return false
  }
  return true
}

export const normalizeDataForm = (value, ref) => {
  // Bool
  if (Array.isArray(ref) && !Array.isArray(value)) {
    return [value]
  }
  if (value === '0') return 0
  if (value === '1') return 1
  if (value === 'true') return true
  else if (value === 'false') return false
  // ...rest
  else return value
}

/* DATE HELPERS */

const convertDate = (value) => {
  let day, month, year

  const separatorsAvailable = ['/', '-', '.', ' ']
  const separator = separatorsAvailable.filter((item) => value.includes(item))

  if (separator.length === 0) {
    day = value.substr(0, 2)
    month = value.substr(2, 2)
    year = value.substr(4, 4)
  } else {
    const data = value.split(separator)
    day = data[0]
    month = data[1]
    if (data[2]) {
      year = data[2].length === 2 ? '20' + data[2] : data[2]
    } else {
      year = moment().format('YYYY')
    }
  }
  return {
    day,
    month,
    year
  }
}

export const isFloat = (value) => {
  return Number(value) === value && value % 1 !== 0
}

export const isInt = (value) => {
  return Number(value) === value && value % 1 === 0
}

export const isStringFloat = (value) => {
  if (String(value).indexOf(',') !== -1) {
    const arr = String(value).split(',')
    if (!isNaN(Number(arr[0])) && !isNaN(Number(arr[1]))) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const convertNumberForUi = (value) => {
  let n = null
  if (isInt(value)) n = Number(value).toFixed(2)
  if (isFloat(value)) n = value
  const arr = String(n).split('.')
  return String(`${arr[0]},${arr[1]}`)
}

export const isSqlDate = (date) => {
  const regEx = /^([0-9]{2,4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]{1,3})Z/y
  return regEx.test(date)
}

export const isUiDate = (date) => {
  return moment(date, 'DD/MM/YYYY', true).isValid()
}

export const isUiDateTime = (date) => {
  return moment(date, 'DD/MM/YYYY HH:mm', true).isValid()
}

export const isAlreadyConvertDate = (date) => {
  const regEx = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}/y
  return regEx.test(date)
}

export const convertDateForUi = (date) => {
  return moment(date).format('DD/MM/YYYY')
}

export const convertDateTimeForUi = (date) => {
  if (moment(date).utc().format('HH:mm') === '00:00') return moment(date).utc().format('DD/MM/YYYY')
  else return moment(date).format('DD/MM/YYYY HH:mm')
}

export const convertDateForApi = (date) => {
  return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
}

export const convertDateTimeForApi = (date) => {
  return moment(date, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm')
}

export const convertFloatForApi = (value) => {
  const arr = String(value).split(',')
  return parseFloat(`${arr[0]}.${arr[1]}`)
}

export const convertAndCheckDate = (value) => {
  const {day, month, year} = convertDate(value)
  const momentDate = moment(new Date(year, month, day))
  if (momentDate.isValid) return true
  else return false
}

export const convertDateFromDirective = (date) => {
  const {day, month, year} = convertDate(date)
  return moment(new Date(year, month - 1, day)).format('DD/MM/YYYY')
}

export const currentDate = () => {
  return moment().format('DD/MM/YYYY')
}

/* AMOUNT HELPERS */

export const convertAmount = (value) => {
  const clean = String(value).replace(/\s+/g, '').replace(/,+/g, '.')
  if (clean.indexOf('.') !== -1) {
    const float = String(Number(clean).toFixed(2)).replace(/\.+/g, ',')
    return float
  } else {
    return String(Number(clean).toFixed(2)).replace(/\.+/g, ',')
  }
}

/* PHONE NUMBER HELPERS */

export const convertTelNumberForUi = (value) => {
  if (value.indexOf('+') === 0) return value
  if (value.length === 10) {
    const arr = value.split('')
    return `${arr[0]}${arr[1]} ${arr[2]}${arr[3]} ${arr[4]}${arr[5]} ${arr[6]}${arr[7]} ${arr[8]}${arr[9]}`
  }
}

export const convertTelNumberFromDirective = (tel) => {
  let newTel = null
  newTel = tel.replace(/[^\d+]/g, '')
  if (newTel.substr(0, 2) === '00') {
    const formatTel = `+${newTel.slice(2, tel.length)}`
    return formatTel
  }
  return newTel
}

export const isFrenchMobileNumber = (tel) => {
  const regEx = /^(?:(?:\+|00)33|0)[67]\d{8}$/y
  return regEx.test(tel)
}

/* OTHER HELPERS */

export const currentConseillerId = () => {
  const storeRef: any = store
  const me: any = storeRef.state.auth.me
  return me ? me.ID : null
}
